import React, { useState, useEffect } from 'react';
import { Container, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, TextField, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// Remove the CSS import if you don't have DocumentModels.css
// import './DocumentModels.css';

export default function DocumentModels() {
    const [models, setModels] = useState([]);
    const [total, setTotal] = useState(0);
    const [filterText, setFilterText] = useState('');
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const navigate = useNavigate();

    useEffect(() => {
        fetchModels();
    }, [page, pageSize, filterText]);

    async function fetchModels() {
        try {
            const query = new URLSearchParams({
                page: page.toString(),
                pageSize: pageSize.toString(),
                filter: filterText
            });
            const response = await fetch(`/api/DocumentModels?${query.toString()}`, {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
            });
            if (response.ok) {
                const data = await response.json();
                setModels(data?.models ?? []);
                setTotal(data?.total ?? 0);
            }
        } catch (error) {
            console.error("Error fetching document models:", error);
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setPageSize(parseInt(event.target.value, 10));
        setPage(1);
    };

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                AI Document Models
            </Typography>
            <Box mb={2}>
                <TextField
                    label="Search Models"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={filterText}
                    onChange={(e) => { setFilterText(e.target.value); setPage(1); }}
                />
            </Box>
            <Paper>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Created At</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {models.map((model) => (
                            <TableRow key={model.id} hover>
                                <TableCell>{model.id}</TableCell>
                                <TableCell>{model.name}</TableCell>
                                <TableCell>{model.status}</TableCell>
                                <TableCell>{new Date(model.createdAt).toLocaleString()}</TableCell>
                            </TableRow>
                        ))}
                        {models.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={4}>No models found.</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={total}
                    page={page - 1}
                    onPageChange={handleChangePage}
                    rowsPerPage={pageSize}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 20, 50]}
                />
            </Paper>
        </Container>
    );
}
